<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <!-- Add subscriber button -->
        <v-btn
          color="#E20613"
          @click="dialog = true"
          class="mb-4"
          dark
        >
          Adicionar Utilizador
        </v-btn>

        <!-- Data table -->
        <v-data-table
          :headers="headers"
          :items="subscribers"
          :items-per-page="5"
          class="elevation-1"
        ></v-data-table>

        <!-- Dialog form -->
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <v-card>
            <v-card-title>Atribuir subscrição</v-card-title>
            <v-card-text>
              <v-form @submit.prevent="addSubscriber">
                <v-text-field
                  v-model="newSubscriber.email"
                  label="Email"
                  required
                  type="email"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="dialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addSubscriber"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from 'sweetalert2'
export default {
  name: 'UsersSubscricao',
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Subscription Date', value: 'subscription_date' }
      ],
      subscribers: [
        {
          name: 'John Doe',
          email: 'john@example.com',
          subscription_date: '2025-07-15'
        },
        {
          name: 'Jane Smith',
          email: 'jane@example.com',
          subscription_date: '2025-07-20'
        },
        {
          name: 'Mike Johnson',
          email: 'mike@example.com',
          subscription_date: '2025-07-25'
        }
      ],
      newSubscriber: {
        email: ''
      }
    }
  },
  methods: {
    addSubscriber() {
      if (this.newSubscriber.email) {
        // Add new subscriber with current date
        console.log('Adding subscriber:', this.newSubscriber.email)
        this.newSubscriber.email = '' // Reset form
        this.dialog = false // Close dialog
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Please enter a valid email address.'
        }) // Show error if email is empty
      }
    }
  }
}
</script>
